import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { getStudents, createStudent, getAttendance, getRegistration, deleteStudent } from '../api/campusClasses2.api';
import { IStudent, IGetStudents, IStudentReq, IAttendance, IGetAttendance, IRegistration, IGetRegistration } from '../models/campusClasses2.model';

interface IStudentState {
  students?: IStudent[];
  attendance?: IAttendance[];
  registration?: IRegistration;
  isLoading: boolean;
  error?: AxiosError | string;
};

const initialState: IStudentState = {
  students: [],
  attendance: [],
  registration: undefined,
  isLoading: false
};

const classStudentSlicer = createSlice({
  name: 'classStudent',
  initialState,
  reducers: {
    getClassStudentsStart: (state: IStudentState) => {
      state.students = [];
      state.isLoading = true;
      state.error = undefined;
    },
    getClassStudentsSuccess: (state: IStudentState, action: PayloadAction<IGetStudents>) => {
      state.students = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getClassStudentsFailure: (state: IStudentState, action: PayloadAction<AxiosError|string>) => {
      state.students = [];
      state.isLoading = false;
      state.error = action.payload;
    },
    getAttendanceStart: (state: IStudentState) => {
      state.attendance = [];
      state.isLoading = true;
      state.error = undefined;
    },
    getAttendanceSuccess: (state: IStudentState, action: PayloadAction<IGetAttendance>) => {
      state.attendance = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getAttendanceFailure: (state: IStudentState, action: PayloadAction<AxiosError | string>) => {
      state.attendance = [];
      state.isLoading = false;
      state.error = action.payload;
    },
    getRegistrationStart: (state: IStudentState) => {
      state.registration = undefined;
      state.isLoading = true;
      state.error = undefined;
    },
    getRegistrationSuccess: (state: IStudentState, action: PayloadAction<IGetRegistration>) => {
      state.registration = action.payload.data;
      state.isLoading = false;
      state.error = undefined;
    },
    getRegistrationFailure: (state: IStudentState, action: PayloadAction<AxiosError | string>) => {
      state.registration = undefined;
      state.isLoading = false;
      state.error = action.payload;
    },
    requestStart: (state: IStudentState) => {
      state.isLoading = true;
      state.error = undefined;
    },
    requestFailure: (state: IStudentState, action: PayloadAction<AxiosError|string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    createSuccess: (state: IStudentState) => {
      state.isLoading = false;
      state.error = undefined;
    },
    // updateSuccess: (state: IStudentState) => {
    //   state.isLoading = false;
    //   state.error = undefined;
    // },
    deleteSuccess: (state: IStudentState) => {
      state.isLoading = false;
      state.error = undefined;
    }
  }
});

export const {
  getClassStudentsStart,
  getClassStudentsSuccess,
  getClassStudentsFailure,
  getAttendanceStart,
  getAttendanceSuccess,
  getAttendanceFailure,
  getRegistrationStart,
  getRegistrationSuccess,
  getRegistrationFailure,
  requestStart,
  requestFailure,
  createSuccess,
  // updateSuccess,
  deleteSuccess
} = classStudentSlicer.actions;

export default classStudentSlicer.reducer;

export const doGetClassStudents = (classCode: string, semesterCode?: number): any => async (dispatch: any) => {
  try {
    dispatch(getClassStudentsStart());
    const response = await getStudents(classCode, semesterCode);
    dispatch(getClassStudentsSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getClassStudentsFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doGetAttendance = (classStudentCode: string): any => async (dispatch: any) => {
  try {
    dispatch(getAttendanceStart());
    const response = await getAttendance(classStudentCode);
    dispatch(getAttendanceSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getAttendanceFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doGetRegistration = (classCode: string, memberCode: string): any => async (dispatch: any) => {
  try {
    dispatch(getRegistrationStart());
    const response = await getRegistration(classCode, memberCode);
    dispatch(getRegistrationSuccess(response.data));
    return response;
  } catch (e: any) {
    dispatch(getRegistrationFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

export const doCreateClassStudent = (classCode: string, data: IStudentReq): any => async (dispatch: any) => {
  try {
    dispatch(requestStart());
    const response = await createStudent(classCode, data);
    dispatch(createSuccess());
    return response;
  } catch (e: any) {
    dispatch(requestFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};

// export const doUpdateStudent = (id: string, data: IStudentReq): any => async (dispatch: any) => {
//   try {
//     dispatch(requestStart());
//     const response = await updateStudent(id, data);
//     dispatch(updateSuccess());
//     return response;
//   } catch (e: any) {
//     dispatch(requestFailure(e.response?.data?.data || e.message));
//     return e.response;
//   }
// };

export const doDeleteStudent = (classStudentCode: number): any => async (dispatch: any) => {
  try {
    dispatch(requestStart());
    const response = await deleteStudent(classStudentCode);
    dispatch(deleteSuccess());
    return response;
  } catch (e: any) {
    dispatch(requestFailure(e.response?.data?.data || e.message));
    return e.response;
  }
};
